import React from 'react';

import styled from 'styled-components';
import { Divider1, StyledBox } from 'styles/common';

import { QUESTION_FORM_SOURCES } from 'constants/ProjectConstants';

import { Typography5 } from 'uiToolkit/Typography';

import QuestionRow from './QuestionRow';

const TemplateQuestionList = ({ data, handleAddQuestion, type, exclusions, source }) => (
  <>
    <StyledBox padding="0rem 2rem 1rem 2rem">
      <Typography5 color="textSecondary">{data?.length} Questions</Typography5>
    </StyledBox>
    <Divider1 gutterBottom={2} />
    <ScrollableQuestionsContainer source={source}>
      {data.map((question) => (
        <QuestionRow
          key={question.id}
          question={question}
          handleAddQuestion={handleAddQuestion}
          exclusions={exclusions}
          source={source}
        />
      ))}
    </ScrollableQuestionsContainer>
  </>
);

export default TemplateQuestionList;

const ScrollableQuestionsContainer = styled.div`
  height: ${(props) => (props.source === QUESTION_FORM_SOURCES.REVIEW ? '70vh' : '55vh')};
  padding: 1rem 2rem;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 0;
    background: transparent; /* Optional: just make scrollbar invisible */
  }
  &::-webkit-scrollbar-thumb {
    background: #ff0000;
  }
`;
